import React, { useCallback, useEffect, useRef } from "react"

function MainEditor({userData, firebase, darkMode, model, isMobile, userInputImage, removeImageFromEditor}) {
  return <></>
}

export default MainEditor
